import { ButtonHTMLAttributes, forwardRef, RefObject } from 'react';
import { styled } from 'styled-components';

import { isLink } from '@numa-group/ui.button-or-link';

import Chevron from './chevron';
import { ActionItemButtonWrapper, ActionItemLinkWrapper, IconWrapper, TextWrapper } from './styles';
import { ActionProps } from './types';

const Action = forwardRef<HTMLButtonElement | HTMLAnchorElement, ActionProps>(
  ({ children, icon, rightIcon = <Chevron />, mobileVariant, isMuted, ...restProps }, ref) => {
    const content = (
      <>
        <IconWrapper>{icon}</IconWrapper>
        <TextWrapper>{children}</TextWrapper>
        {rightIcon}
      </>
    );

    if (isLink(restProps)) {
      return (
        <ActionItemLinkWrapper
          ref={ref as RefObject<HTMLAnchorElement>}
          $isMuted={isMuted}
          $mobileVariant={mobileVariant}
          {...restProps}
        >
          {content}
        </ActionItemLinkWrapper>
      );
    }

    return (
      <ActionItemButtonWrapper
        ref={ref as RefObject<HTMLButtonElement>}
        $isMuted={isMuted}
        $mobileVariant={mobileVariant}
        {...(restProps as ButtonHTMLAttributes<HTMLButtonElement>)}
      >
        {content}
      </ActionItemButtonWrapper>
    );
  },
);

Action.displayName = 'ActionItem';
export default styled(Action)``;
